<template>
  <div class="task-page">
    <van-nav-bar title="我的任务" left-arrow @click-left="$router.back()"/>
    <section v-if="unread.length" class="notice-list">
      <button v-for="item in unread" :key="item.id" @click="openNotice(item)">
        <i></i><span><b>{{ item.title }}</b><small>{{ item.content }}</small></span>
        <time>{{ date(item.createdAt) }}</time>
      </button>
    </section>
    <main>
      <div class="tabs">
        <button v-for="item in tabs" :key="item.value" :class="{active:tab===item.value}" @click="tab=item.value">{{ item.label }}</button>
      </div>
      <article v-for="item in filtered" :key="item.kind + '-' + item.id" @click="openTask(item)">
        <header><em :class="item.assignmentType.toLowerCase()">{{ item.assignmentTypeLabel }}</em><span
          :class="item.status.toLowerCase()">{{ status(item.status) }}</span></header>
        <h2>{{ item.title }}</h2>
        <p>{{ item.content }}</p>
        <footer><span>截止 {{ date(item.dueAt) }}</span><b v-if="item.kind === 'performance'">绩效权重 {{ item.performanceWeight }}%</b><b v-else>完成率 {{ item.completionRate || 0 }}%</b></footer>
      </article>
      <van-empty v-if="!filtered.length" description="暂无任务"/>
    </main>
  </div>
</template>
<script>import coreapi from '@/utils/coreapi';

function field(row, key) {
  if (!row) return '';
  return row[key] !== undefined ? row[key] : row[key.toUpperCase()];
}

function mapProjectTask(row) {
  return {
    id: field(row, 'id'),
    kind: 'project',
    assignmentType: 'PROJECT',
    assignmentTypeLabel: '项目任务',
    title: field(row, 'title'),
    content: field(row, 'objective') || field(row, 'description') || '',
    acceptanceCriteria: field(row, 'acceptance_criteria') || '',
    dueAt: field(row, 'due_at') || field(row, 'end_at'),
    status: field(row, 'status') || 'ASSIGNED',
    performanceWeight: 0,
    completionRate: field(row, 'completion_rate') || 0,
    raw: row
  };
}

export default {
  data() {
    return {
      projectTasks: [],
      performanceTasks: [],
      notifications: [],
      tab: 'ACTIVE',
      tabs: [{label: '待处理', value: 'ACTIVE'}, {label: '待验收', value: 'SUBMITTED'}, {label: '已完成', value: 'VERIFIED'}, {
        label: '全部',
        value: 'ALL'
      }]
    }
  }, computed: {
    tasks() {
      const perf = (this.performanceTasks || []).map(v => Object.assign({kind: 'performance'}, v));
      return this.projectTasks.concat(perf);
    },
    unread() {
      return this.notifications.filter(v => !v.readAt)
    }, filtered() {
      if (this.tab === 'ALL') return this.tasks;
      if (this.tab === 'ACTIVE') return this.tasks.filter(v => ['ASSIGNED', 'IN_PROGRESS', 'RETURNED'].includes(v.status));
      return this.tasks.filter(v => v.status === this.tab)
    }
  }, mounted() {
    Promise.all([
      coreapi.availableTasks().catch(() => []),
      coreapi.tasks().catch(() => []),
      coreapi.notifications()
    ]).then(v => {
      this.projectTasks = (v[0] || []).map(mapProjectTask);
      this.performanceTasks = v[1] || [];
      this.notifications = v[2] || [];
    }).catch(e => this.$toast.fail(e.message))
  }, methods: {
    openTask(item) {
      this.$router.push({
        name: 'EfficiencyTaskDetail',
        params: {id: item.id},
        query: {kind: item.kind}
      });
    },
    async openNotice(v) {
      await coreapi.readNotification(v.id);
      const type = v.type || '';
      if (['CORRECTION_CHANGE_REQUESTED', 'CORRECTION_DISPUTED', 'CORRECTION_SUBMITTED'].includes(type)) {
        this.$router.push({name: 'SupervisorCorrections'});
        return
      }
      if (type.indexOf('CORRECTION_') === 0) {
        this.$router.push({name: 'EfficiencyCorrectionDetail', params: {id: v.assignmentId}});
        return
      }
      if (type === 'WEEKLY_BRIEF_READY') {
        this.$router.push({name: 'SupervisorWeeklyBrief'});
        return
      }
      this.$router.push({name: 'EfficiencyTaskDetail', params: {id: v.assignmentId}, query: {kind: 'performance'}})
    }, date(v) {
      return v ? new Date(v).toLocaleString('zh-CN', {month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}) : '--'
    }, status(v) {
      return {ASSIGNED: '待开始', IN_PROGRESS: '进行中', SUBMITTED: '待验收', VERIFIED: '已完成', RETURNED: '已退回'}[v] || v
    }
  }
}</script>
<style lang="less" scoped>@import '~@/assets/base.less';

.task-page {
  min-height: 100vh;
  padding-bottom: .4rem;
  background: #f6f7fb
}

.notice-list, main {
  margin: .28rem;
  background: #fff;
  border-radius: .24rem;
  box-shadow: 0 .08rem .3rem rgba(211, 47, 47, .1);
  overflow: hidden
}

.notice-list button {
  width: 100%;
  padding: .24rem;
  display: flex;
  align-items: center;
  border-top: 1PX solid #eee
}

.notice-list button:first-child {
  border: 0
}

.notice-list i {
  width: .14rem;
  height: .14rem;
  margin-right: .16rem;
  border-radius: 50%;
  background: #D32F2F
}

.notice-list span {
  min-width: 0;
  flex: 1;
  text-align: left
}

.notice-list b, .notice-list small {
  display: block
}

.notice-list b {
  font-size: .29rem
}

.notice-list small {
  margin-top: .05rem;
  color: #898c9e;
  font-size: .24rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.notice-list time {
  margin-left: .12rem;
  color: #aaa;
  font-size: .21rem
}

.tabs {
  padding: .2rem;
  display: flex;
  gap: .1rem;
  border-bottom: 1PX solid #eee;
  overflow: auto
}

.tabs button {
  padding: .12rem .2rem;
  white-space: nowrap;
  color: #777b90;
  border-radius: .28rem;
  background: #f6f7fb
}

.tabs button.active {
  color: #fff;
  background: @color
}

main article {
  padding: .28rem;
  border-top: 1PX solid #eee
}

main article:first-of-type {
  border-top: 0
}

article header, article footer {
  display: flex;
  justify-content: space-between
}

article em {
  padding: .05rem .13rem;
  color: @color;
  font-size: .22rem;
  font-style: normal;
  background: #fff5f5;
  border-radius: .24rem
}

article em.project {
  color: #1565c0;
  background: #eef5ff
}

article em.major {
  color: #a66b10;
  background: #fff3df
}

article header span {
  font-size: .23rem
}

.submitted {
  color: #e48b18
}

.verified {
  color: #2d9b61
}

.returned {
  color: #D32F2F
}

article h2 {
  margin: .16rem 0 .08rem;
  font-size: .34rem
}

article p {
  display: -webkit-box;
  overflow: hidden;
  color: #777b90;
  font-size: .26rem;
  line-height: 1.5;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2
}

article footer {
  margin-top: .18rem;
  color: #9295a7;
  font-size: .23rem
}

article footer b {
  color: @color
}</style>



// WEBPACK FOOTER //
// src/views/efficiency/Tasks.vue